import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { useDayPicker } from 'contexts/DayPicker';
/** Render a button HTML element applying the reset class name. */
export var Button = forwardRef(function (props, ref) {
    var _a = useDayPicker(), classNames = _a.classNames, styles = _a.styles;
    var classNamesArr = [classNames.button_reset, classNames.button];
    if (props.className) {
        classNamesArr.push(props.className);
    }
    var className = classNamesArr.join(' ');
    var style = __assign(__assign({}, styles.button_reset), styles.button);
    if (props.style) {
        Object.assign(style, props.style);
    }
    return (_jsx("button", __assign({}, props, { ref: ref, type: "button", className: className, style: style })));
});
//# sourceMappingURL=Button.js.map